import createReactComponent from '../createReactComponent';
export default createReactComponent('seven', 'Seven', [["path",{"d":"M10.5 17c0-3.75 5-10 5-10s-3.75.625-6.25 0","key":"svg-0"}]]);